import { Navigate } from "react-router-dom"
import Dashboard from "../pages/Dashboard";

// Auth
import Login from "pages/Authentication/login";
import Logout from "pages/Authentication/Logout";
import ForgotPassword from "pages/Authentication/ForgotPassword";
import SignUp from "pages/Authentication/Register"
import SearchDocumentPage from "pages/HumanResources/DocumentGenerator/SearchDocuments";
import GeneratorPage from "pages/HumanResources/DocumentGenerator/GenerateDocuments";
import OrgChartPage from "pages/HumanResources/OrganizationChart/OrgChart";
import FullScreenOrgChartPage from "pages/HumanResources/OrganizationChart/FullScreenOrgChart";
import DemographicsPage from "pages/HumanResources/Demographics";
import EmployeeListPage from "pages/HumanResources/EmployeeList";
import EmergencyContactsPage from "pages/HumanResources/EmergencyContact";
import UsersPage from "pages/Admin/Users";
import RolesPage from "pages/Admin/Roles";
import DepartmentLevelsPage from "pages/Admin/DepartmentLevels";
import BillabilityUtilizationTargetsPage from "pages/Admin/BillabilityUtilizationTargets";
import ProjectHealthRulesPage from "pages/Admin/ProjectHealthRules";
import ProjectMarginTargetsPage from "pages/Admin/ProjectMarginTargets";
import RegionMappingPage from "pages/Admin/RegionMapping";
import ClientMappingPage from "pages/Admin/ClientMapping";
import FiscalYearsPage from "pages/Admin/FiscalYears";
import LambdaTrackerPage from "pages/Admin/LambdaTracker";
import LambdaDetailsPage from "pages/Admin/LambdaTracker/LambdaDetails";
import MemosPage from "pages/Admin/SystemUpdatesMemo";
import MemoDetailsPage from "pages/Admin/SystemUpdatesMemo/MemoDetails";
import VersionLogPage from "pages/VersionLog";
import DepartmentsPage from "pages/Admin/Departments";
import CreateDepartmentPage from "pages/Admin/Departments/CreateDepartment";
import DepartmentDetailsPage from "pages/Admin/Departments/DepartmentDetails";
import EditDepartmentPage from "pages/Admin/Departments/EditDepartment";
import CreateDepartmentKPIPage from "pages/Admin/Departments/CreateDepartmentKPI";
import EditDepartmentKPIPage from "pages/Admin/Departments/EditDepartmentKPI";
import OpportunitiesPage from "pages/BusinessDevelopment/Opportunities";
import UnAuthorizedPage from "pages/UnAuthorized";
import { MANUALS_PAGE, UNAUTHORIZED_PAGE, VERSION_LOG_PAGE } from "./AuthProtected";
import HumanResourcesDashboard from "pages/HumanResources";
import HRDashboardPage from "pages/HumanResources/Dashboard";
import HRDashboardSettingsPage from "pages/HumanResources/Dashboard/Settings";
import HRDashboardPrintPage from "pages/HumanResources/Dashboard/Print";
import ReportViewPage from "pages/Reports/ReportView";
import AnalyticsPage from "pages/Admin/Analytics";
import DepartmentKPIsPage from "pages/Admin/DepartmentKPIs";
import AdminDashboardPage from "pages/Admin";
import ExecutiveDashboard from "pages/Executive";
import BusinessDevelopmentDashboard from "pages/BusinessDevelopment";
import FinanceDashboard from "pages/Finance";
import EmployeeDetailsPage from "pages/HumanResources/EmployeeList/EmployeeDetails";
import CreateConsultantPage from "pages/HumanResources/ConsultantsList/CreateConsultant";
import EditConsultantPage from "pages/HumanResources/ConsultantsList/EditConsultant";
import DocumentsPage from "pages/HumanResources/DocumentGenerator/Documents";
import ProjectManagmentDashboard from "pages/ProjectManagment";
import ProjectListPage from "pages/ProjectManagment/ProjectList";
import ProjectDetailsPage from "pages/ProjectManagment/ProjectList/ProjectDetails";
import RetentionPage from "pages/HumanResources/Retention";
import AnniversaryPage from "pages/HumanResources/Anniversary";
import ProfilePage from "pages/Profile";
import ManualsPage from "pages/Manuals";
import ManualViewPage from "pages/Manuals/ManualView";
import ManualPrintPage from "pages/Manuals/ManualPrint";
import RocksListPage from "pages/BusinessDevelopment/RocksList";
import CreateRocksPage from "pages/BusinessDevelopment/RocksList/CreateRocks";
import IndustryEngagementPage from "pages/BusinessDevelopment/IndustryEngagement";
import ClientEngagementPage from "pages/BusinessDevelopment/ClientEngagement";
import OpportunityForecastPage from "pages/BusinessDevelopment/OpportunityForecast";
import ProjectProfitabilityPage from "pages/ProjectManagment/ProjectProfitability";
import EditRocksPage from "pages/BusinessDevelopment/RocksList/EditRocks";
import ClientPage from "pages/BusinessDevelopment/Client";
import ClientDetailsPage from "pages/BusinessDevelopment/Client/ClientDetails";
import BudgetAcutalsPage from "pages/Finance/BudgetActuals";
import FinancialKPIPage from "pages/Finance/FinancialKPI";
import ProjectForecast from "pages/ProjectManagment/ProjectForecast";
import DepartmentBudgetsPage from "pages/Finance/DepartmentBudgets";
import ExpenseBudgetsPage from "pages/Finance/ExpenseBudgets";
import ExpenseBudgetDetailsPage from "pages/Finance/ExpenseBudgets/ExpenseBudgetDetails";
import GrossMarginReportPage from "pages/Finance/GrossMarginReport";
import ConsultingRevenueVsBudgetPage from "pages/Finance/ConsultingRevenueVsBudget";
import CreateClientEngagement from "pages/BusinessDevelopment/ClientEngagement/CreateClientEngagement";
import EditClientEngagement from "pages/BusinessDevelopment/ClientEngagement/EditClientEngagement";
import CreateIndustryEngagement from "pages/BusinessDevelopment/IndustryEngagement/CreateIndustryEngagement";
import EditIndustryEngagement from "pages/BusinessDevelopment/IndustryEngagement/EditIndustryEngagement";
import ConsultingIncomePage from "pages/Finance/ConsultingIncome";
import BillabilityPage from "pages/Finance/Billability";
import ConsultantAgreementPage from "pages/HumanResources/ConsultantAgreement";
import ContinuingEducationListPage from "pages/Forms/ContinuingEducation";
import CreateContinuingEducationPage from "pages/Forms/ContinuingEducation/CreateContinuingEducation";
import ContinuingEducationDetailsPage from "pages/Forms/ContinuingEducation/ContinuingEducationDetails";
import EditContinuingEducationPage from "pages/Forms/ContinuingEducation/EditContinuingEducation";
import ContinuingEducationPrintPage from "pages/Forms/ContinuingEducation/ContinuingEducationPrint";

const authProtectedRoutes = [
  { path: "/human-resources", component: <HumanResourcesDashboard /> },
  { path: "/human-resources/dashboard", component: <HRDashboardPage /> },
  { path: "/human-resources/dashboard/settings", component: <HRDashboardSettingsPage /> },
  { path: "/human-resources/document-generator/", component: <DocumentsPage /> },
  { path: "/human-resources/document-generator/search", component: <SearchDocumentPage /> },
  { path: "/human-resources/document-generator/generate", component: <GeneratorPage /> },
  { path: "/human-resources/document-generator/consultant-agreement", component: <ConsultantAgreementPage /> },
  { path: "/human-resources/org-chart", component: <OrgChartPage /> },
  { path: "/human-resources/demographics", component: <DemographicsPage /> },
  { path: "/human-resources/employees", component: <EmployeeListPage /> },
  { path: "/human-resources/employees/employee", component: <EmployeeDetailsPage /> },
  { path: "/human-resources/consultants/create", component: <CreateConsultantPage /> },
  { path: "/human-resources/consultants/edit", component: <EditConsultantPage /> },
  { path: "/human-resources/emergency-contacts", component: <EmergencyContactsPage /> },
  { path: "/human-resources/retention", component: <RetentionPage /> },
  { path: "/human-resources/anniversary", component: <AnniversaryPage /> },
  { path: "/business-development/opportunities", component: <OpportunitiesPage /> },
  { path: "/business-development", component: <BusinessDevelopmentDashboard /> },
  { path: "/business-development/opportunity-forecast", component: <OpportunityForecastPage /> },
  { path: "/business-development/rocks", component: <RocksListPage /> },
  { path: "/business-development/rocks/create", component: <CreateRocksPage /> },
  { path: "/business-development/rocks/edit", component: <EditRocksPage /> },
  { path: "/business-development/industry-engagement", component: <IndustryEngagementPage /> },
  { path: "/business-development/industry-engagement/create", component: <CreateIndustryEngagement /> },
  { path: "/business-development/industry-engagement/edit", component: <EditIndustryEngagement /> },
  { path: "/business-development/client-engagement", component: <ClientEngagementPage /> },
  { path: "/business-development/client-engagement/create", component: <CreateClientEngagement /> },
  { path: "/business-development/client-engagement/edit", component: <EditClientEngagement /> },
  { path: "/business-development/client", component: <ClientPage /> },
  { path: "/business-development/client/details", component: <ClientDetailsPage /> },
  { path: "/project-managment", component: <ProjectManagmentDashboard /> },
  { path: "/project-managment/projects", component: <ProjectListPage /> },
  { path: "/project-managment/projects/project", component: <ProjectDetailsPage /> },
  { path: "/project-managment/project-profitability", component: <ProjectProfitabilityPage /> },
  { path: "/project-managment/forecast", component: <ProjectForecast /> },
  { path: "/admin/users", component: <UsersPage /> },
  { path: "/admin/roles", component: <RolesPage /> },
  { path: "/admin/department-levels", component: <DepartmentLevelsPage /> },
  { path: "/admin/billability-utilization-targets", component: <BillabilityUtilizationTargetsPage /> },
  { path: "/admin/project-health-rules", component: <ProjectHealthRulesPage /> },
  { path: "/admin/project-margin-targets", component: <ProjectMarginTargetsPage /> },
  { path: "/admin/region-mapping", component: <RegionMappingPage /> },
  { path: "/admin/client-mapping", component: <ClientMappingPage /> },
  { path: "/admin/fiscal-years", component: <FiscalYearsPage /> },
  { path: "/admin/lambda-tracker/details", component: <LambdaDetailsPage /> },
  { path: "/admin/lambda-tracker", component: <LambdaTrackerPage /> },
  { path: "/admin/system-updates-memo/details", component: <MemoDetailsPage /> },
  { path: "/admin/system-updates-memo", component: <MemosPage /> },
  { path: "/admin/analytics", component: <AnalyticsPage /> },
  { path: "/admin/department-kpis", component: <DepartmentKPIsPage /> },
  { path: "/admin/departments/create", component: <CreateDepartmentPage /> },
  { path: "/admin/departments/details", component: <DepartmentDetailsPage /> },
  { path: "/admin/departments/edit", component: <EditDepartmentPage /> },
  { path: "/admin/departments/kpi/create", component: <CreateDepartmentKPIPage /> },
  { path: "/admin/departments/kpi/edit", component: <EditDepartmentKPIPage /> },
  { path: "/admin/departments", component: <DepartmentsPage /> },
  { path: "/admin", component: <AdminDashboardPage /> },
  { path: "/executive", component: <ExecutiveDashboard /> },
  { path: "/executive/active-projects", component: <ExecutiveDashboard /> },
  { path: "/executive/work-in-progress", component: <ExecutiveDashboard /> },
  { path: "/finance", component: <FinanceDashboard /> },
  { path: "/finance/financial-kpi", component: <FinancialKPIPage /> },
  { path: "/finance/budget-actual", component: <BudgetAcutalsPage /> },
  { path: "/finance/department-budgets", component: <DepartmentBudgetsPage /> },
  { path: "/finance/expense-budgets/details", component: <ExpenseBudgetDetailsPage /> },
  { path: "/finance/expense-budgets", component: <ExpenseBudgetsPage /> },
  { path: "/finance/gross-margin", component: <GrossMarginReportPage /> },
  // Old URL (bookmarks, e-mails)
  { path: "/finance/gross-margin-report", component: <Navigate to="/finance/gross-margin" replace /> },
  { path: "/finance/consulting-revenue-budget", component: <ConsultingRevenueVsBudgetPage /> },
  { path: "/finance/consulting-income", component: <ConsultingIncomePage /> },
  { path: "/finance/billability", component: <BillabilityPage /> },
  { path: "/forms/continuing-education", component: <ContinuingEducationListPage /> },
  { path: "/forms/continuing-education/create", component: <CreateContinuingEducationPage /> },
  { path: "/forms/continuing-education/:id", component: <ContinuingEducationDetailsPage /> },
  { path: "/forms/continuing-education/edit/:id", component: <EditContinuingEducationPage /> },
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/profile", component: <ProfilePage /> },
  { path: MANUALS_PAGE, component: <ManualsPage /> },
  { path: VERSION_LOG_PAGE, component: <VersionLogPage /> },
  // Manual slugs are always "<module>/<name>"
  { path: `${MANUALS_PAGE}/:module/:name`, component: <ManualViewPage /> },
  { path: UNAUTHORIZED_PAGE, component: <UnAuthorizedPage /> },
  { path: "/", exact: true, component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
  { path: "/register", component: <SignUp /> },
  {
    // "Organization Chart" — the whole-org synthetic entry (see getCharts thunk)
    path: "/PKi444qT38NEcpKAuudE4s50lzOeNeXJ7q0E9mgFOG7uBGL188lxwNiSnxuxajNZSbLKlolklLPVRaGkWnMUkSe7Oe8hPamtpsn1", component: <FullScreenOrgChartPage
      departmentCode="ROOT"
    />
  },
  {
    path: "/mkwy663FnqX0pbcntLDCRsFMXoIDmzxWrmmh3IQKpYWXzHCIS5FC6c6HvORscA0ZlRDUz39yhxHEQqChLFJ0dQPP4pYOO4DNSMrC", component: <FullScreenOrgChartPage
      departmentCode="PS"
    />
  },
  {
    path: "/U5QkV3eLs0ZndVt0Y1du37SPg2hmecwgriaVmnEgIGGh6sy5M39okSBHCwFNEatYqJptvpHBL6CD82FNUCm6yefIjiWWrkCIMWm4", component: <FullScreenOrgChartPage
      departmentCode="PD"
    />
  },

  {
    path: "/Bh1Bilx0Nhyn8gvLiuSXiv72ecw9ODpU", component: <FullScreenOrgChartPage
      departmentCode="MPP"
    />
  },
]
// Every list/report page can open <page>/print and <page>/export (pages/Reports/ReportView renders a
// snapshot of the table the user was viewing). The URL keeps the page's screen, so access is the same.
const REPORT_PAGES = [
  "/finance/billability",
  "/finance/budget-actual",
  "/finance/department-budgets",
  "/finance/expense-budgets",
  "/finance/gross-margin",
  "/finance/consulting-revenue-budget",
  "/finance/consulting-income",
  "/project-managment/projects",
  "/project-managment/project-profitability",
  "/project-managment/forecast",
  "/business-development/opportunity-forecast",
  "/business-development/client",
  "/business-development/client-engagement",
  "/business-development/industry-engagement",
  "/business-development/rocks",
  "/human-resources/employees",
  "/human-resources/document-generator",
  "/human-resources/document-generator/search",
  "/forms/continuing-education",
  "/admin/users",
  "/admin/roles",
  "/admin/departments",
  "/admin/department-levels",
  "/admin/billability-utilization-targets",
  "/admin/project-health-rules",
  "/admin/project-margin-targets",
  "/admin/region-mapping",
  "/admin/client-mapping",
  "/admin/fiscal-years",
  "/admin/department-kpis",
]

// Logged in, but rendered without the app layout (no sidebar/header) so the page looks like the document.
const printRoutes = [
  ...REPORT_PAGES.flatMap(page => [
    { path: `${page}/print`, component: <ReportViewPage kind="print" /> },
    { path: `${page}/export`, component: <ReportViewPage kind="export" /> },
  ]),
  { path: "/forms/continuing-education/print/:id", component: <ContinuingEducationPrintPage /> },
  { path: "/human-resources/dashboard/print", component: <HRDashboardPrintPage /> },
  { path: `${MANUALS_PAGE}/:module/:name/print`, component: <ManualPrintPage /> },
]

export { authProtectedRoutes, publicRoutes, printRoutes };
